import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { addDirectory } from "../../../Redux/Directory/action";
import { useDispatch, useSelector } from "react-redux";

const DirectoryModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer?.data);
  const accountID = user?.accountID;
  const [directoryData, setDirectoryData] = useState({
    name: "",
    email: "",
    phone: "",
    department: "",
  });
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const body = {
        accountID,
        ...directoryData,
      };
      await addDirectory(dispatch, body);
      setDirectoryData({
        name: "",
        email: "",
        phone: "",
        department: "",
      });
      onHide();

    }
    setValidated(true);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDirectoryData({
      ...directoryData,
      [name]: name === "department" ? value.toUpperCase() : value,
    });
  };

  const handleClose = () => {
    setDirectoryData({
      name: "",
      email: "",
      phone: "",
      department: "",
    });
    setValidated(false)
    onHide();
  };

  return (
      <Modal show={show} onHide={handleClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Add Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                  required
                  type="text"
                  name="name"
                  value={directoryData.name}
                  onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                  required
                  type="email"
                  name="email"
                  value={directoryData.email}
                  onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid email.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                  required
                  type="tel"
                  name="phone"
                  value={directoryData.phone}
                  onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a phone number.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formDepartment">
              <Form.Label>Department</Form.Label>
              <Form.Control
                  required
                  type="text"
                  name="department"
                  value={directoryData.department}
                  onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a department.
              </Form.Control.Feedback>
            </Form.Group>
              <div className={"mt-3 d-flex justify-content-between"}>
            <Button className="custom-button" onClick={handleClose}>
              Close
            </Button>
            <Button className="custom-button" type="submit">
              Add
            </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
  );
};

export default DirectoryModal;
